<Cell {header} {priority} type="avatar" {colspan} {rowspan}>
    <span class="screen-reader" slot="header">{text}</span>
    <div slot="data">
        <Avatar src={src} size={200}></Avatar>
    </div>
</Cell>

<script>
    import Cell from '../../Cell/v1/Cell.svelte';
    import Avatar from '../../../nodes/Avatar/v1/Avatar.svelte';

    /** @type {string} */
    export let text = '';
    /** @type {string} */
    export let src = '';
    /** @type {boolean} */
    export let header = false;
    /** @type {number} */
    export let colspan = 1;
    /** @type {number} */
    export let rowspan = 1;
    /** @type {1|2|3} */
    export let priority = 1;
</script>
